import { MarketplaceBasketItem } from './marketplace-basket-item.model';

export class MarketplaceBasket {
  public items: MarketplaceBasketItem[] = [];
  public total: number;

  public updateBasket(basket: MarketplaceBasket) {
    this.items = basket.items;
    this.total = basket.total;
  }
}
